import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=6a7ac7bc&scoped=true&"
import script from "./InputLabel.vue?vue&type=script&lang=js&"
export * from "./InputLabel.vue?vue&type=script&lang=js&"
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=6a7ac7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ac7bc",
  null
  
)

export default component.exports